import { SvgIcon } from '@material-ui/core';
import { ReactComponent as rightArrow } from './right_arrow.svg';

export default function RightArrowIcon(props) {
  return <SvgIcon {...props} component={rightArrow} viewBox="0 0 8 8" />;
}
